import StarterpackDetail from './StarterpackDetailWrap';
export default StarterpackDetail;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/StarterpackDetail/index.ts